import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const Blog: React.FC = () => {
  const { t } = useTranslation();

  // const blogPosts = [
  //   {
  //     id: 1,
  //     title: 'The Future of Accounting: How AI Automation is Transforming Financial Processes',
  //     excerpt: 'Discover how artificial intelligence is revolutionizing the accounting industry, from automated invoice processing to intelligent financial analysis.',
  //     author: 'Alenis Team',
  //     date: 'January 15, 2025',
  //     readTime: '8 min read',
  //     category: 'AI & Automation',
  //     featured: true,
  //     slug: 'future-of-accounting-ai-automation',
  //     content: `
  //       <h2>The Accounting Revolution is Here</h2>
  //       <p>The accounting industry is experiencing a seismic shift. Traditional manual processes that have been the backbone of financial management for decades are being replaced by intelligent automation systems powered by artificial intelligence.</p>
  //       
  //       <h3>What is AI-Powered Accounting Automation?</h3>
  //       <p>AI-powered accounting automation refers to the use of machine learning algorithms, natural language processing, and computer vision to automate repetitive accounting tasks. This includes:</p>
  //       <ul>
  //         <li><strong>Invoice Processing:</strong> Automatically extract data from invoices, validate information, and match against purchase orders</li>
  //         <li><strong>Expense Management:</strong> Categorize expenses, detect anomalies, and ensure compliance with company policies</li>
  //         <li><strong>Financial Reporting:</strong> Generate real-time reports and insights from financial data</li>
  //         <li><strong>Audit Preparation:</strong> Automatically organize documents and flag potential issues</li>
  //       </ul>
  //       
  //       <h3>The Benefits Are Transformative</h3>
  //       <p>Companies implementing AI automation in their accounting processes are seeing remarkable results:</p>
  //       
  //       <h4>1. Dramatic Time Savings</h4>
  //       <p>Manual invoice processing typically takes 5-10 minutes per invoice. AI automation reduces this to seconds, allowing accounting teams to focus on strategic activities rather than data entry.</p>
  //       
  //       <h4>2. Improved Accuracy</h4>
  //       <p>Human error rates in manual data entry can be as high as 1-2%. AI systems achieve accuracy rates of 99.5% or higher, significantly reducing costly mistakes.</p>
  //       
  //       <h4>3. Cost Reduction</h4>
  //       <p>Organizations report 80-90% reduction in processing costs per invoice when implementing AI automation. This translates to significant savings, especially for companies processing thousands of invoices monthly.</p>
  //       
  //       <h4>4. Enhanced Compliance</h4>
  //       <p>AI systems can automatically ensure compliance with regulations, flagging potential issues before they become problems. This is particularly valuable for companies operating in multiple jurisdictions.</p>
  //       
  //       <h3>Real-World Success Stories</h3>
  //       <p>Consider the case of a mid-sized manufacturing company that implemented AI automation for their accounts payable process:</p>
  //       <ul>
  //         <li>Reduced invoice processing time from 5 days to 2 hours</li>
  //         <li>Achieved 99.7% accuracy in data extraction</li>
  //         <li>Saved $150,000 annually in processing costs</li>
  //         <li>Improved vendor relationships through faster payments</li>
  //       </ul>
  //       
  //       <h3>The Technology Behind the Magic</h3>
  //       <p>Modern AI accounting systems leverage several advanced technologies:</p>
  //       
  //       <h4>Machine Learning</h4>
  //       <p>Algorithms learn from historical data to improve accuracy over time. The more invoices processed, the better the system becomes at recognizing patterns and extracting relevant information.</p>
  //       
  //       <h4>Natural Language Processing (NLP)</h4>
  //       <p>NLP enables systems to understand context and meaning in financial documents, not just extract text. This allows for intelligent categorization and anomaly detection.</p>
  //       
  //       <h4>Computer Vision</h4>
  //       <p>Advanced OCR technology can read handwritten notes, understand complex layouts, and extract data from various document formats with high accuracy.</p>
  //       
  //       <h3>Getting Started with AI Automation</h3>
  //       <p>For companies considering AI automation, here are the key steps:</p>
  //       
  //       <h4>1. Assess Current Processes</h4>
  //       <p>Identify repetitive, time-consuming tasks that could benefit from automation. Invoice processing, expense categorization, and report generation are common starting points.</p>
  //       
  //       <h4>2. Choose the Right Solution</h4>
  //       <p>Look for platforms that offer:</p>
  //       <ul>
  //         <li>Easy integration with existing systems</li>
  //         <li>High accuracy rates</li>
  //         <li>Scalability for growing businesses</li>
  //         <li>Strong security and compliance features</li>
  //       </ul>
  //       
  //       <h4>3. Start Small, Scale Fast</h4>
  //       <p>Begin with a pilot program focusing on one process. Once you see results, gradually expand automation to other areas of your accounting workflow.</p>
  //       
  //       <h4>4. Train Your Team</h4>
  //       <p>Ensure your accounting team understands how to work with AI systems. The goal is augmentation, not replacement – AI handles routine tasks while humans focus on analysis and strategy.</p>
  //       
  //       <h3>The Future is Bright</h3>
  //       <p>As AI technology continues to advance, we can expect even more sophisticated automation capabilities. Future developments may include:</p>
  //       <ul>
  //         <li>Predictive analytics for cash flow management</li>
  //         <li>Automated tax optimization</li>
  //         <li>Real-time fraud detection</li>
  //         <li>Intelligent financial planning and forecasting</li>
  //       </ul>
  //       
  //       <h3>Conclusion</h3>
  //       <p>AI automation is not just a trend – it's the future of accounting. Companies that embrace this technology today will have significant competitive advantages tomorrow. The question isn't whether to implement AI automation, but how quickly you can get started.</p>
  //       
  //       <p>At Alenis, we're proud to be at the forefront of this revolution, helping businesses transform their financial processes through intelligent automation. Ready to see what AI can do for your accounting team? Contact us today to learn more about our solutions.</p>
  //     `
  //   }
  // ];
  
  const blogPosts: any[] = [];

  const sharePost = (post: typeof blogPosts[0], platform: string) => {
    const url = encodeURIComponent(`${window.location.origin}/blog/${post.slug}`);
    const title = encodeURIComponent(post.title);
    const text = encodeURIComponent(post.excerpt);
    
    let shareUrl = '';
    
    switch (platform) {
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
        break;
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
        break;
      case 'copy':
        navigator.clipboard.writeText(`${window.location.origin}/blog/${post.slug}`);
        alert('Link copied to clipboard!');
        return;
    }
    
    if (shareUrl) {
      window.open(shareUrl, '_blank', 'width=600,height=400');
    }
  };

  const categories = ['All', 'AI & Automation', 'Compliance', 'Regulations', 'Technology'];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-indigo-900 text-white overflow-hidden relative">
      {/* Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-gradient-to-r from-blue-500/30 to-cyan-500/30 rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-32 right-16 w-96 h-96 bg-gradient-to-r from-purple-500/30 to-pink-500/30 rounded-full blur-3xl animate-float-delayed"></div>
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:50px_50px]"></div>
      </div>

      {/* Header */}
      <header className="relative z-10 bg-white/5 backdrop-blur-xl border-b border-white/10 sticky top-0">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3 group">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-400 via-cyan-500 to-indigo-600 rounded-2xl flex items-center justify-center shadow-xl group-hover:shadow-2xl group-hover:shadow-blue-500/25 transition-all duration-300 group-hover:scale-105">
                <span className="text-white font-bold text-xl">A</span>
              </div>
              <span className="text-3xl font-black bg-gradient-to-r from-white via-blue-100 to-cyan-200 bg-clip-text text-transparent tracking-tight">Alenis</span>
            </Link>
            <div className="flex items-center space-x-6">
              <LanguageSwitcher />
              <Link to="/" className="px-6 py-3 text-white/80 hover:text-white transition-all duration-300 hover:bg-white/10 rounded-xl backdrop-blur-sm">
                {t('navigation.home')}
              </Link>
              <Link to="/about" className="px-6 py-3 text-white/80 hover:text-white transition-all duration-300 hover:bg-white/10 rounded-xl backdrop-blur-sm">
                {t('about.footer.aboutUs')}
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative z-10 pt-24 pb-20">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-6xl md:text-8xl font-black mb-8 leading-tight">
            <span className="block bg-gradient-to-r from-white via-blue-100 to-cyan-200 bg-clip-text text-transparent tracking-tight">
              {t('blog.title')}
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-slate-300 mb-12 max-w-4xl mx-auto leading-relaxed">
            {t('blog.subtitle')}
          </p>
        </div>
      </section>

      {/* Featured Post */}
      {/* <section className="relative z-10 py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-6">Featured Article</h2>
          </div>
          
          <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-3xl p-8 border border-white/10 hover:border-white/20 transition-all">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="flex items-center space-x-4 mb-6">
                  <span className="px-4 py-2 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 border border-blue-400/30 rounded-full text-blue-300 text-sm font-semibold">
                    {blogPosts[0].category}
                  </span>
                  <span className="px-4 py-2 bg-gradient-to-r from-green-500/20 to-emerald-500/20 border border-green-400/30 rounded-full text-green-300 text-sm font-semibold">
                    Featured
                  </span>
                </div>
                
                <h3 className="text-3xl font-bold text-white mb-6 leading-tight">
                  {blogPosts[0].title}
                </h3>
                
                <p className="text-xl text-slate-300 leading-relaxed mb-8">
                  {blogPosts[0].excerpt}
                </p>
                
                <div className="flex items-center space-x-6 text-slate-400 mb-8">
                  <div className="flex items-center space-x-2">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                    <span>{blogPosts[0].author}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <span>{blogPosts[0].date}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span>{blogPosts[0].readTime}</span>
                  </div>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-4">
                  <button className="px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-600 text-white text-lg font-bold rounded-xl hover:from-blue-700 hover:to-cyan-700 transition-all shadow-xl hover:shadow-2xl hover:shadow-blue-500/25 transform hover:scale-105">
                    Read Full Article
                  </button>
                  
                  <div className="flex items-center space-x-3">
                    <span className="text-slate-400 text-sm">Share:</span>
                    <button
                      onClick={() => sharePost(blogPosts[0], 'linkedin')}
                      className="p-2 bg-blue-600/20 border border-blue-400/30 rounded-lg hover:bg-blue-600/30 transition-all"
                      title="Share on LinkedIn"
                    >
                      <svg className="w-5 h-5 text-blue-300" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                      </svg>
                    </button>
                    <button
                      onClick={() => sharePost(blogPosts[0], 'twitter')}
                      className="p-2 bg-blue-500/20 border border-blue-400/30 rounded-lg hover:bg-blue-500/30 transition-all"
                      title="Share on Twitter"
                    >
                      <svg className="w-5 h-5 text-blue-300" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                      </svg>
                    </button>
                    <button
                      onClick={() => sharePost(blogPosts[0], 'copy')}
                      className="p-2 bg-slate-600/20 border border-slate-400/30 rounded-lg hover:bg-slate-600/30 transition-all"
                      title="Copy Link"
                    >
                      <svg className="w-5 h-5 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              
              <div className="bg-gradient-to-br from-blue-500/20 to-cyan-500/20 border border-blue-400/30 rounded-2xl p-8">
                <div className="space-y-6">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-white">AI Innovation</h4>
                      <p className="text-slate-300">Cutting-edge technology</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-500 rounded-xl flex items-center justify-center">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-white">Efficiency Gains</h4>
                      <p className="text-slate-300">80-90% time savings</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-white">Accuracy</h4>
                      <p className="text-slate-300">99.5%+ precision</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* All Posts */}
      <section className="relative z-10 py-20 bg-gradient-to-br from-slate-800/60 to-slate-900/60 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center">
            <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-3xl p-12 border border-white/10">
              <svg className="w-16 h-16 text-slate-400 mx-auto mb-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <h2 className="text-3xl font-bold text-white mb-4">{t('blog.noBlogsAvailable')}</h2>
            </div>
          </div>
          
          {/* <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <div key={post.id} className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:border-white/20 transition-all group">
                <div className="flex items-center space-x-4 mb-4">
                  <span className="px-3 py-1 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 border border-blue-400/30 rounded-full text-blue-300 text-sm font-semibold">
                    {post.category}
                  </span>
                  {post.featured && (
                    <span className="px-3 py-1 bg-gradient-to-r from-green-500/20 to-emerald-500/20 border border-green-400/30 rounded-full text-green-300 text-sm font-semibold">
                      Featured
                    </span>
                  )}
                </div>
                
                <h3 className="text-xl font-bold text-white mb-4 group-hover:text-blue-300 transition-colors leading-tight">
                  {post.title}
                </h3>
                
                <p className="text-slate-300 leading-relaxed mb-6">
                  {post.excerpt}
                </p>
                
                <div className="flex items-center justify-between text-slate-400 text-sm mb-6">
                  <div className="flex items-center space-x-4">
                    <span>{post.author}</span>
                    <span>•</span>
                    <span>{post.date}</span>
                  </div>
                  <span>{post.readTime}</span>
                </div>
                
                <div className="flex flex-col gap-3">
                  <button className="w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-cyan-700 transition-all">
                    Read More
                  </button>
                  
                  <div className="flex items-center justify-center space-x-2">
                    <button
                      onClick={() => sharePost(post, 'linkedin')}
                      className="p-2 bg-blue-600/20 border border-blue-400/30 rounded-lg hover:bg-blue-600/30 transition-all"
                      title="Share on LinkedIn"
                    >
                      <svg className="w-4 h-4 text-blue-300" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                      </svg>
                    </button>
                    <button
                      onClick={() => sharePost(post, 'twitter')}
                      className="p-2 bg-blue-500/20 border border-blue-400/30 rounded-lg hover:bg-blue-500/30 transition-all"
                      title="Share on Twitter"
                    >
                      <svg className="w-4 h-4 text-blue-300" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                      </svg>
                    </button>
                    <button
                      onClick={() => sharePost(post, 'copy')}
                      className="p-2 bg-slate-600/20 border border-slate-400/30 rounded-lg hover:bg-slate-600/30 transition-all"
                      title="Copy Link"
                    >
                      <svg className="w-4 h-4 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div> */}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="relative z-10 py-20">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <div className="bg-gradient-to-br from-blue-500/20 to-cyan-500/20 border border-blue-400/30 rounded-3xl p-12">
            <h2 className="text-4xl font-bold text-white mb-6">Stay Updated</h2>
            <p className="text-xl text-slate-300 mb-8 max-w-3xl mx-auto">
              Get the latest insights on AI-powered accounting delivered straight to your inbox. No spam, just valuable content.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-6 py-4 bg-slate-700/50 border border-slate-600 rounded-xl text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              <button className="px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-bold rounded-xl hover:from-blue-700 hover:to-cyan-700 transition-all">
                Subscribe
              </button>
            </div>
            
            <p className="text-slate-400 text-sm mt-4">
              Join 1,000+ professionals already subscribed
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative z-10 bg-slate-900/80 backdrop-blur-sm border-t border-white/10 py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8 mb-12">
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-cyan-500 rounded-xl flex items-center justify-center">
                  <span className="text-white font-bold text-xl">A</span>
                </div>
                <span className="text-3xl font-bold bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">Alenis</span>
              </div>
              <p className="text-slate-400 text-lg max-w-md leading-relaxed">
                Revolutionizing financial management through artificial intelligence and advanced accounting process automation.
              </p>
            </div>
            
            <div>
              <h4 className="text-white font-semibold text-lg mb-4">Company</h4>
              <ul className="space-y-3 text-slate-400">
                <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
                <li><Link to="/careers" className="hover:text-white transition-colors">Careers</Link></li>
                <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
                <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-white font-semibold text-lg mb-4">Product</h4>
              <ul className="space-y-3 text-slate-400">
                <li><a href="#" className="hover:text-white transition-colors">AI Automation</a></li>
                <li><a href="#" className="hover:text-white transition-colors">PDF Analysis</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Reporting</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Integrations</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-white/10 pt-8 text-center">
            <div className="text-slate-400 text-sm">
              © 2025 Alenis. All rights reserved. Powered by AI.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Blog;
